import { Text } from '@medly-components/core';
import { STATION_ICON_SIZE, STATION_SIZE } from 'constants/map';
import styled, { css } from 'styled-components';
import { Direction } from 'types';
import { rgba } from 'polished';
import { mapTourActiveElementAnimationStyles } from 'pages/Map/components/MapTour/MapTour.styled';

const selectedPathConnectingIconCommonStyle = css<{ isPathSelectedInTour?: boolean }>`
    border: 0.2rem dashed ${({ theme, isPathSelectedInTour }) => (isPathSelectedInTour ? theme.colors.coral[500] : theme.colors.black)};
`;

/**
 * Based on where path connecting left/right/top/bottom removes border in that direction
 */
export const selectedPathConnectingIconStyleMap = {
    [Direction.DOWN]: css`
        ${selectedPathConnectingIconCommonStyle}
        border-bottom: transparent;
        border-bottom-style: dashed;
    `,
    [Direction.UP]: css`
        ${selectedPathConnectingIconCommonStyle}
        border-top: transparent;
        border-top-style: dashed;
    `,
    [Direction.LEFT]: css`
        ${selectedPathConnectingIconCommonStyle}
        border-left: transparent;
        border-left-style: dashed;
    `,
    [Direction.RIGHT]: css`
        ${selectedPathConnectingIconCommonStyle}
        border-right: transparent;
        border-right-style: dashed;
    `,
    [Direction.NONE]: css``
};

export const IconWrapper = styled.div<{ selectedPathIntersectionDirection?: Direction | null; isPathSelectedInTour: boolean }>`
    width: ${STATION_SIZE}px;
    height: ${STATION_SIZE}px;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.royalBlue[200]};
    border-radius: 3.2rem;
    padding: 0.6rem;
    cursor: pointer;
    box-sizing: border-box;
    ${({ selectedPathIntersectionDirection }) =>
        selectedPathIntersectionDirection ? selectedPathConnectingIconStyleMap[selectedPathIntersectionDirection] : ''};

    svg {
        width: ${STATION_ICON_SIZE}px;
        height: ${STATION_ICON_SIZE}px;
    }
`;

export const tourActiveElementStyles = css`
    ${IconWrapper} {
        border: 0.1rem solid ${({ theme }) => theme.colors.coral[500]};
        ${mapTourActiveElementAnimationStyles}
        &::before {
            border-radius: 3.2rem;
        }
    }
`;

export const StationWrapper = styled.div<{ isMapTourActiveElement: boolean }>`
    position: absolute;
    border-radius: 3.2rem;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ isMapTourActiveElement }) => isMapTourActiveElement && tourActiveElementStyles};
`;

export const ZoneStartStationAnimation = styled.div`
    @keyframes startStationAnimation {
        0% {
            width: ${STATION_SIZE}px;
            height: ${STATION_SIZE}px;
        }

        100% {
            width: ${2 * STATION_SIZE}px;
            height: ${2 * STATION_SIZE}px;
        }
    }
    width: ${STATION_SIZE}px;
    height: ${STATION_SIZE}px;
    position: absolute;
    animation: startStationAnimation 1s ease-in;
    animation-iteration-count: infinite;
    z-index: -1;
    background: ${({ theme }) => rgba(theme.colors.coral[500], 0.12)};
    border: 0.1rem solid ${({ theme }) => theme.colors.coral[500]};
    border-radius: 50%;
`;

export const TimelineWrapper = styled(Text)`
    position: absolute;
    padding: 0.4rem 2rem 0.4rem 1.2rem;
    border-radius: 2rem;
    color: ${({ theme }) => theme.colors.silverGrey[900]};
    border: 0.1rem solid ${({ theme }) => theme.colors.silverGrey[900]};
    background-color: ${({ theme }) => theme.colors.white};
    right: calc(100% - 1.5rem);
    z-index: -1;
    width: max-content;
`;
